import { ISubWindowContent, SubWindow } from "../../SmartTools/Components";
import React, { useEffect, useState } from "react";
import Close from "@material-ui/icons/Close";
import { ContextProvider } from "../../SmartTools/Components/";
import { DataFeedStatusDetail } from "../DataFeedStatus";
import { DataFeedStatusTitle } from "./";
import IconButton from "@material-ui/core/IconButton";
import { IDataFeedStatusTitle } from "./DataFeedStatusTableTitle";
import MaterialTable from "material-table";
import Snackbar from "@material-ui/core/Snackbar";

// TODO: remove this eslint disable an fix the lints
/* eslint-disable react/display-name */

type DataFeedStatus = {
    status: number;
    uniqueName: string;
    dataFeedName: string;
    frequency: string;
    category: string;
    overdue: string;
    lastSuccessfulRun: string;
    lastRun: string;
    dataOwner: string;
};

export const DataFeedStatusTable: React.FunctionComponent =
    (): React.ReactElement => {
        const [dataFeed, setDataFeed] = useState<DataFeedStatus[]>([]);

        const [detailsWindowOpen, setDetailsWindowOpen] = useState(false);

        const [msgBoxOpen, setMsgBoxOpen] = useState(false);

        const [selectedUniqueName, setSelectedUniqueName] = useState(``);

        const [dataFeedName, setDataFeedName] = useState(``);

        useEffect(() => {
            void getInfo();
        }, []);

        const getInfo = async (): Promise<void> => {
            const stringResult: string = await $.ajax(
                `/DataFeedStatus/GetDataFeedStatus`,
                { method: `GET` },
            );

            const result: DataFeedStatus[] = JSON.parse(stringResult);

            setDataFeed(result);
        };

        const title: IDataFeedStatusTitle[] = [
            { word: "= File Loaded", color: "#88BD39" },
            { word: "= File Unsuccessful", color: "#E52030" },
            { word: "= Identified Issue", color: "#FFC000" },
        ];

        const closeWindow = (): void => {
            setSelectedUniqueName(``);
            setDataFeedName(``);
            setDetailsWindowOpen(false);
            setMsgBoxOpen(false);
        };

        const action = (
            <IconButton
                aria-label={`close`}
                color={`inherit`}
                onClick={closeWindow}
                size={`small`}
            >
                <Close fontSize={`small`} />
            </IconButton>
        );

        const message = (
            <React.Fragment>
                <img
                    className={`DataFeedStatus-InfoIcon`}
                    height={`17px`}
                    src={`/Images/InfoIcon.svg`}
                    width={`17px`}
                />
                <div>Drilldown not available for this type of data feed</div>
            </React.Fragment>
        );

        const detailNode: React.ReactNode = (
            <DataFeedStatusDetail uniqueName={selectedUniqueName} />
        );

        const detailsProps: ISubWindowContent = {
            body: detailNode,
            horizontalPos: `Center`,
            isDominant: false,
            moduleID: 230004,
            subWindowKey: `dataFeedStatus`,
            title: `Past 14 Load Instances: ${dataFeedName}`,
            verticalPos: `Center`,
        };

        const detailsSubWindow: React.ReactNode = (
            <SubWindow closeWindow={closeWindow} content={detailsProps} />
        );

        const msgBoxSubWindow: React.ReactNode = (
            <Snackbar
                action={action}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={3000}
                ContentProps={{
                    style: { backgroundColor: `#142937`, color: `#ffffff` },
                }}
                message={message}
                onClose={closeWindow}
                open={true}
            />
        );

        const onClick = (
            uniqueName: string,
            dataFeedName,
            category: string,
        ): void => {
            closeWindow();
            if (category === "Applications") {
                setMsgBoxOpen(true);
            } else {
                setSelectedUniqueName(uniqueName);
                setDataFeedName(dataFeedName);
                setDetailsWindowOpen(true);
            }
        };

        return (
            <ContextProvider>
                <div className={`scroll-style`}>
                    <MaterialTable
                        columns={[
                            {
                                field: `dataFeedName`,
                                title: `Data Feed`,
                                cellStyle: { padding: `5px` },
                                render: (rowData): React.ReactElement => (
                                    <div>
                                        <div
                                            className={`datafeedstatusBox`}
                                            style={{
                                                backgroundColor:
                                                    title[
                                                        rowData.status === 0
                                                            ? 1
                                                            : rowData.status ===
                                                                1
                                                              ? 2
                                                              : 0
                                                    ].color,
                                            }}
                                        />
                                        <p> {rowData.dataFeedName}</p>
                                    </div>
                                ),
                            },
                            {
                                field: `category`,
                                title: `Category`,
                                cellStyle: { padding: `5px` },
                            },
                            {
                                field: `frequency`,
                                title: `Expected Frequency`,
                                cellStyle: { padding: `5px` },
                                customSort: (a, b): number =>
                                    (a.category === `Applications`
                                        ? `-`
                                        : a.frequency) >
                                    (b.category === `Applications`
                                        ? `-`
                                        : b.frequency)
                                        ? 1
                                        : -1,
                                render: (rowData): React.ReactElement => (
                                    <p>
                                        {rowData.category === `Applications`
                                            ? `-`
                                            : rowData.frequency}
                                    </p>
                                ),
                            },
                            {
                                field: `overdue`,
                                title: `Overdue?`,
                                cellStyle: { padding: `5px` },
                                customSort: (a, b): number =>
                                    (a.category === `Applications`
                                        ? `N/A`
                                        : a.overdue) >
                                    (b.category === `Applications`
                                        ? `N/A`
                                        : b.overdue)
                                        ? 1
                                        : -1,
                                render: (rowData): React.ReactElement => (
                                    <p>
                                        {rowData.category === `Applications`
                                            ? `N/A`
                                            : rowData.overdue}
                                    </p>
                                ),
                            },
                            {
                                field: `lastRun`,
                                title: `Last File Received`,
                                cellStyle: { padding: `5px` },
                                customSort: (a, b): number => {
                                    if (a.lastRun === `N/A`) {
                                        return -1;
                                    }

                                    if (b.lastRun === `N/A`) {
                                        return 1;
                                    }

                                    const splitPeriodsA = a.lastRun.split(` `),
                                        splitPeriodsB = b.lastRun.split(` `);

                                    const splitDaysA: number[] =
                                            splitPeriodsA[0]
                                                .split(`/`)
                                                .map((a) => Number(a))
                                                .reverse(),
                                        splitDaysB: number[] = splitPeriodsB[0]
                                            .split(`/`)
                                            .map((a) => Number(a))
                                            .reverse();

                                    const splitTimeA: number[] =
                                            splitPeriodsA[1]
                                                .split(`:`)
                                                .map((a) => Number(a)),
                                        splitTimeB: number[] = splitPeriodsB[1]
                                            .split(`:`)
                                            .map((a) => Number(a));

                                    const finalDateA = new Date(
                                            splitDaysA[0],
                                            splitDaysA[1] - 1,
                                            splitDaysA[2],
                                            ...splitTimeA,
                                        ),
                                        finalDateB = new Date(
                                            splitDaysB[0],
                                            splitDaysB[1] - 1,
                                            splitDaysB[2],
                                            ...splitTimeB,
                                        );

                                    return finalDateA > finalDateB ? 1 : -1;
                                },
                            },
                            {
                                field: `lastSuccessfulRun`,
                                title: `Last Successfully Loaded`,
                                cellStyle: { padding: `5px` },
                                customSort: (a, b): number => {
                                    if (a.lastSuccessfulRun === `N/A`) {
                                        return -1;
                                    }

                                    if (b.lastSuccessfulRun === `N/A`) {
                                        return 1;
                                    }

                                    const splitPeriodsA =
                                            a.lastSuccessfulRun.split(` `),
                                        splitPeriodsB =
                                            b.lastSuccessfulRun.split(` `);

                                    const splitDaysA: number[] =
                                            splitPeriodsA[0]
                                                .split(`/`)
                                                .map((a) => Number(a))
                                                .reverse(),
                                        splitDaysB: number[] = splitPeriodsB[0]
                                            .split(`/`)
                                            .map((a) => Number(a))
                                            .reverse();

                                    const splitTimeA: number[] =
                                            splitPeriodsA[1]
                                                .split(`:`)
                                                .map((a) => Number(a)),
                                        splitTimeB: number[] = splitPeriodsB[1]
                                            .split(`:`)
                                            .map((a) => Number(a));

                                    const finalDateA = new Date(
                                            splitDaysA[0],
                                            splitDaysA[1] - 1,
                                            splitDaysA[2],
                                            ...splitTimeA,
                                        ),
                                        finalDateB = new Date(
                                            splitDaysB[0],
                                            splitDaysB[1] - 1,
                                            splitDaysB[2],
                                            ...splitTimeB,
                                        );

                                    return finalDateA > finalDateB ? 1 : -1;
                                },
                            },
                            {
                                field: `dataOwner`,
                                title: `Data Owner`,
                                cellStyle: { padding: `5px` },
                            },
                        ]}
                        data={dataFeed}
                        onRowClick={(event, rowData): void =>
                            onClick(
                                rowData.uniqueName,
                                rowData.dataFeedName,
                                rowData.category,
                            )
                        }
                        options={{
                            draggable: false,
                            headerStyle: {
                                backgroundColor: `#395364`,
                                padding: `5px`,
                            },
                            maxBodyHeight: "10vh",
                            minBodyHeight: "75vh",
                            overflowY: "initial",
                            paging: false,
                        }}
                        style={{ height: `100%`, padding: `8px` }}
                        title={<DataFeedStatusTitle keyElements={title} />}
                    />
                </div>
                {detailsWindowOpen && detailsSubWindow}
                {msgBoxOpen && msgBoxSubWindow}
            </ContextProvider>
        );
    };
